/** Filtra servicios vinculados al modelo del vehículo. */
export function filterServicesForVehicle(services = [], vehicle) {
  if (!services?.length) return [];

  const modelId = vehicle?.modelId || vehicle?.model?.id;
  if (!modelId) return [];

  return services.filter((service) => {
    const links = service.serviceModels || [];
    if (links.length === 0) return true;
    return links.some((sm) => {
      const id = sm.modelId ?? sm.model?.id;
      return Number(id) === Number(modelId);
    });
  });
}

export function getVehicleModelId(vehicle) {
  return vehicle?.modelId || vehicle?.model?.id || null;
}

export function buildServicesQueryParams(serviceTypeId, vehicle, { forAgenda = true } = {}) {
  const params = new URLSearchParams();
  params.set('serviceType', String(serviceTypeId));
  const modelId = getVehicleModelId(vehicle);
  if (modelId) params.set('modelId', String(modelId));
  if (forAgenda) params.set('forAgenda', '1');
  return params.toString();
}
